import CurrentIncome from './CurrentIncome';

export default CurrentIncome;
